const style = (theme) => {
  const output = {
    root: {},
    separator: {
      height: '1px',
      backgroundColor: theme.getRgba(theme.colors[1], 0.2),
    },
    roll: {
      paddingTop: 40,
      paddingBottom: 40,
    },
    title: {
      fontFamily: theme.fonts[0],
      fontSize: 14,
      textTransform: 'uppercase',
      borderBottom: `1px solid ${theme.getRgba(theme.colors[1], 0.2)}`,
      borderTop: `1px solid ${theme.getRgba(theme.colors[1], 0.2)}`,
      paddingTop: '10px !important',
      paddingBottom: '10px !important',
    },
  }

  return output
}

export default style
